export default __webpack_public_path__ + "fk-cp-zion/img/error-500_cd3e64.png";